
    import * as React from 'react';

    const Calendar20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M5 2H6V3.5H10V2H11V3.5H15V2H16V3.5H19H19.5V4V18V18.5H19H1H0.5V18V4V3.5H1H5V2ZM11 4.5H15V6H16V4.5H18.5V7H1.5V4.5H5V6H6V4.5H10V6H11V4.5ZM1.5 8V17.5H18.5V8H1.5ZM5 10H9V11H5V10ZM9 14H5V15H9V14ZM11 10H15V11H11V10ZM15 14H11V15H15V14Z" /></svg>
        </div>
      );
    };

    Calendar20.displayName = 'Calendar20';

    export default Calendar20;
  